import authCheckApp from './authCheckApp'

/**
 * 隐藏安卓原生导航栏
 * @since 1.0.0
 * @example
 * 
 * hiddenNavigation()
 */
function hiddenNavigation() {
    authCheckApp()
        .then(() => {
        // 发起请求
            window.WebViewJavascriptBridge.callHandler('hiddenNavigation', {}, (response) => {
                return response
            })
        })
}

export default hiddenNavigation